export default function SvgBottom4() {
    return (
      <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0"
        y="0"
        cursor="pointer"
        width="10px"
        fill="#666"
        enableBackground="new 0 0 25.93 25.93"
        version="1.1"
        viewBox="0 0 25.93 25.93"
        xmlSpace="preserve"
        >
        <path d="M25.397 4.554h-2.042l-9.974 12.644a.54.54 0 01-.835 0L2.575 4.554H.532a.533.533 0 00-.419.86l12.435 15.762c.104.125.255.2.419.2a.54.54 0 00.416-.2L25.816 5.413a.524.524 0 00.058-.561.524.524 0 00-.477-.298z"></path>
      </svg>
    </>
  );
}